// extracted by mini-css-extract-plugin
export default {"big":"Intro_big__FR8xr","biggest":"Intro_biggest__5FOS8"};